var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.882 3.244C5.814 3.094 5.664 3 5.501 3C5.339 3 5.189 3.094 5.121 3.244L3.738 6.238L0.744 7.618C0.594 7.686 0.5 7.836 0.5 8.001C0.5 8.167 0.594 8.314 0.744 8.382L3.738 9.765L5.118 12.756C5.186 12.905 5.336 13 5.499 13C5.661 13 5.811 12.905 5.879 12.756L7.262 9.762L10.256 8.379C10.405 8.311 10.5 8.161 10.5 7.999C10.5 7.836 10.405 7.686 10.256 7.618L7.265 6.238L5.882 3.244Z",
    fill: "#5067E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.695 2.219L12.167 1.667L12.719 0.195C12.763 0.0780002 12.875 0 13 0C13.125 0 13.237 0.0780002 13.281 0.195L13.833 1.667L15.305 2.219C15.422 2.263 15.5 2.375 15.5 2.5C15.5 2.625 15.422 2.737 15.305 2.781L13.833 3.333L13.281 4.805C13.237 4.922 13.125 5 13 5C12.875 5 12.763 4.922 12.719 4.805L12.167 3.333L10.695 2.781C10.578 2.737 10.5 2.625 10.5 2.5C10.5 2.375 10.578 2.263 10.695 2.219Z",
    fill: "#5067E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.5 12L10.734 12.663C10.594 12.716 10.5 12.85 10.5 13C10.5 13.15 10.594 13.284 10.734 13.337L12.5 14L13.163 15.766C13.216 15.906 13.35 16 13.5 16C13.65 16 13.784 15.906 13.837 15.766L14.5 14L16.266 13.337C16.406 13.284 16.5 13.15 16.5 13C16.5 12.85 16.406 12.716 16.266 12.663L14.5 12L13.837 10.234C13.784 10.094 13.65 10 13.5 10C13.35 10 13.216 10.094 13.163 10.234L12.5 12Z",
    fill: "#5067E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.dba81d7acfa8866d26f3e8b220547b2f.svg";
export { ForwardRef as ReactComponent };